import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { OngsPetViewPage } from './ongs-pet-view.page';

const routes: Routes = [
  {
    path: '',
    component: OngsPetViewPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OngsPetViewPage]
})
export class OngsPetViewPageModule {}
